import { createFileRoute } from '@tanstack/react-router';

import { OperatorsPage } from '@/features/operator/operators-page';

export const Route = createFileRoute('/_operator/operators')({ component: OperatorsPage });
